import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth } from 'aws-amplify';
import { environment } from '../../../../environments/environment';
import { CONSTANTS } from '../../../app.constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public token!: string;
  public defaultRequestParams: IDefaultRequestParams;

  constructor(private http: HttpClient) {
    this.defaultRequestParams = {
      app_id: CONSTANTS.APP_ID,
      //app_version: environment.APP_VERSION,
      device_id: CONSTANTS.DEVICE_ID,
      device_type: CONSTANTS.DEVICE_TYPE,
      sys_user_id: '',
      sys_user_type: '',
    };
  }

  getToken(): string {
    return this.token;
  }

  getDefaultParams(): IDefaultRequestParams {
    return this.defaultRequestParams;
  }

  getDefaultHeaders() {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.token,
    };
    return headers;
  }

  
  logout() {
    window.localStorage.removeItem("mp-serve-auth");
    window.localStorage.removeItem("mpuserdetailslock");
    window.localStorage.removeItem("mpUInfo");
    window.localStorage.removeItem('cookieDetails');
    window.localStorage.removeItem('cookieStartTimer');
    window.localStorage.removeItem('cookieEndTimer');
    Auth.currentAuthenticatedUser().then(() => {
      Auth.signOut();    
    }).catch(() => {
      window.open(environment.config.oauth.redirectSignOut, "_self");
    });
  }

}


export interface IDefaultRequestParams {
  app_id: string;
  //app_version: string;
  device_id: string;
  device_type: string;
  sys_user_id: string;
  sys_user_type: string;
}
